import React from 'react';
import { evidence } from '../data/portfolio';
import { Label } from './Label';
export function Evidence() {
  return <section id="evidence" aria-labelledby="evidence-heading" className="scroll-mt-20 bg-ink px-6 py-20 md:px-10 md:py-24" data-id="element-129" data-mp="29rjj51aj51en">
      <div className="mx-auto w-full max-w-edge" data-id="element-130" data-mp="2enqgw6srv6li">
        <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between" data-id="element-131" data-mp="2jhcty02ulchu">
          <Label data-id="element-132" data-mp="2ngv5w6coyd8j">The Evidence</Label>
          <h2 id="evidence-heading" className="max-w-xl font-display text-xl font-normal leading-relaxed text-paper/90 md:text-right md:text-2xl" data-id="element-133" data-mp="2nhmyr9ewlwv4">
            The record behind the proposition.
          </h2>
        </div>

        <dl className="mt-14 grid grid-cols-2 border-t border-white/15 lg:grid-cols-5" data-id="element-134" data-mp="32ffd3y8psf7q">
          {evidence.map(item => <div key={item.value} className="border-b border-white/10 px-0 py-9 sm:px-6 lg:border-b-0 lg:border-r lg:last:border-r-0 lg:first:pl-0 lg:last:pr-0" data-id="element-135" data-mp="133mg41lxf9v0">
              <dt className="text-gradient font-display text-[2.5rem] font-normal leading-none md:text-5xl" data-id="element-136" data-mp="hu1np53t1fw9">
                {item.value}
              </dt>
              <dd className="mt-4 max-w-[14rem] text-[0.8rem] uppercase leading-relaxed tracking-[0.16em] text-fog" data-id="element-137" data-mp="82dylauq0axy">
                {item.label}
              </dd>
            </div>)}
        </dl>
      </div>
    </section>;
}